import { ref, shallowRef, watch } from 'vue';
import { useRouter } from 'vue-router';
import { defineStore, storeToRefs } from "pinia";
import builderAPI from "../api/builder"

import { useNotifications } from "./notifications.store";
import { useResumesStore } from "./resumes.store";
import { useJobAlertsStore } from './job-alerts.store';

export const usePrimaryResumeStore = defineStore('primary-resume', () => {
    const router = useRouter();
    
    const notificationsStore = useNotifications();
    const resumesStore = useResumesStore();
    const jobAlertsStore = useJobAlertsStore();
    const { resumes } = storeToRefs(resumesStore);

    const newPrimaryResumeId = shallowRef(null);
    const showPrimaryResumeInfo = shallowRef(false);
    const showConfirmModal = shallowRef(false);
    const showSelectPrimaryResume = shallowRef(false);
    const loadingSetPrimary = shallowRef(false);
    const showOfferToSetPrimaryResume = ref(false);
    
    const primaryResume = ref(null);
    
    const setShowConfirmModal = () => {
        showConfirmModal.value = true;
    }
    
    const closeConfirmModal = () => {
        newPrimaryResumeId.value = null;
        showConfirmModal.value = false;
    }

    const setShowPrimaryResumeInfo = () => {
        showPrimaryResumeInfo.value = true;
    }

    const hidePrimaryResumeInfo = () => {
        showPrimaryResumeInfo.value = false;
    }
    
    const setShowSelectPrimaryResume = () => {
        showSelectPrimaryResume.value = true;
    }
    
    const hideSelectPrimaryResume = () => {
        showSelectPrimaryResume.value = false;
    }
    
    const setPrimaryResume = async (resumeId, forced = false) => {
        loadingSetPrimary.value = true;
        
        if(primaryResume.value != null && !forced) {
            newPrimaryResumeId.value = resumeId;
            setShowConfirmModal();
            return;
        }
        
        try {
            primaryResume.value = await builderAPI.resume.setPrimary(resumeId, {
                is_primary: true
            })

            jobAlertsStore.updateUserSettings('job_board_send_recommendations_toggle', 'true')
            notificationsStore.notify("Resume was set as primary!", 'success');
        } catch (error) {
            notificationsStore.notify("Failed to set primary resume!", 'error');
        } finally {
            loadingSetPrimary.value = false;
        }
    }

    const createPrimaryResumeHandler = async () => {
        router.push({ name: 'resumes.edit', query: { set_primary:  true } });
    }
    
    watch(resumes, (newValue) => {
        primaryResume.value = newValue.find(resume => resume?.is_primary === true);

        showOfferToSetPrimaryResume.value = !primaryResume?.value;
    }, {
        deep: true
    })

    return {
        showPrimaryResumeInfo,
        showConfirmModal,
        showSelectPrimaryResume,
        showOfferToSetPrimaryResume,
        newPrimaryResumeId,

        primaryResume,

        setShowConfirmModal,
        closeConfirmModal,
        setShowPrimaryResumeInfo,
        hidePrimaryResumeInfo,
        setShowSelectPrimaryResume,
        hideSelectPrimaryResume,
        setPrimaryResume,
        createPrimaryResumeHandler
    }
})
